// extracted by mini-css-extract-plugin
export var container = "_f2-1";
export var cornerButtonContainer = "_f2-6";
export var disabled = "_f2-2";
export var dragActive = "_f2-3";
export var fileContainer = "_f2-5";
export var hiddenInput = "_f2-4";
export var widthContainer = "_f2-0";